import React from "react";
import {FormattedMessage} from "react-intl";
import {Alert, AlertActions, Button, Icon} from "peggirkit";
import router from "@/routing/Router";
import {ArrowTopRightOnSquareIcon} from "@heroicons/react/24/outline";

type Props = {
    count: number;
};

const EmployeesClockedNotification = ({count}: Props) => {
    return (
        <Alert
            type={"warning"}
            title={<FormattedMessage id={"dayReport.openTimeEntries.title"}/>}
            content={
                <FormattedMessage
                    id={"dayReport.openTimeEntries"}
                    values={{n: count}}
                />
            }
            actions={
                <AlertActions>
                    <Button
                        color={"primary"}
                        variant={"text"}
                        iconAfter={<Icon icon={ArrowTopRightOnSquareIcon}/>}
                        buttonAction={{
                            as: "reactRouterLink",
                            actionProps: {
                                to: router.timesheet.absolutePath(),
                                target: "_blank",
                            },
                        }}
                    >
                        <FormattedMessage id={"timesheet"}/>
                    </Button>
                </AlertActions>
            }
        />
    );
};

export default EmployeesClockedNotification;